
const digest = 'e74c6996938b036d5c4fd1d78a97c3af9ebc30a7d9fde2d3ae69fc4c7735c19f';
const classes = {"wrapper":"_wrapper_dtep7_1","title":"_title_dtep7_1","formWrapper":"_formWrapper_dtep7_5"};
const css = `._wrapper_dtep7_1 ._title_dtep7_1 {
  color: #787878;
  font-size: 14px;
}
._wrapper_dtep7_1 ._formWrapper_dtep7_5 {
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  